import * as DevLauncher from 'expo-dev-launcher';
import * as DevMenu from 'expo-dev-menu';

export { DevMenu, DevLauncher };

export const registerErrorHandlers = DevLauncher.registerErrorHandlers;
export const isDevelopmentBuild = DevLauncher.isDevelopmentBuild;
